// extracted by mini-css-extract-plugin
export default {"section":"SocialProof_section__et7nX","text":"SocialProof_text__ZPGfX","list":"SocialProof_list__3KP9v","item":"SocialProof_item__WF7XU"};